import {inject, Injectable} from '@angular/core';
import {ToastController} from '@ionic/angular';

const DEFAULT_DURATION_TIME = 3000;

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  dismissedToast: boolean;
  prevToast: HTMLIonToastElement;

  private toastController = inject(ToastController);

  constructor() {
    this.dismissedToast = true;
  }

  default(message: string, duration: number = DEFAULT_DURATION_TIME, otherConfig = {}) {
    this.presentToast(message, 'primary', duration, otherConfig);
  }

  info(message: string, duration: number = DEFAULT_DURATION_TIME, otherConfig = {}) {
    this.presentNoMultipleToast(message, 'tertiary', duration, {...otherConfig, icon: 'information-circle-outline'});
  }

  success(message: string, duration: number = DEFAULT_DURATION_TIME, otherConfig = {}) {
    this.presentNoMultipleToast(message, 'success', duration, {...otherConfig, icon: 'checkmark-circle-outline'});
  }

  warning(message: string, duration: number = DEFAULT_DURATION_TIME, otherConfig = {}) {
    this.presentNoMultipleToast(message, 'warning', duration, {...otherConfig, icon: 'alert-circle-outline'});
  }

  danger(message: string, duration: number = DEFAULT_DURATION_TIME, otherConfig = {}) {
    this.presentNoMultipleToast(message, 'danger', duration, {...otherConfig, icon: 'warning-outline'});
  }

  // -------------------------------------------------------------------------------------------------------------------------------------

  private async presentToast(message: string, color: string, duration: number = DEFAULT_DURATION_TIME, otherConfig: any = {}) {

    const config = {
      message,
      color,
      duration,
      cssClass: 'app-toast',
      swipeGesture: 'vertical',
      ...otherConfig
    };

    if(this.prevToast){
      await this.prevToast.dismiss();
    }

    const toast = await this.toastController.create(config);
    this.prevToast = toast;
    await toast.present();
    await toast.onWillDismiss().then(() => {
      this.dismissedToast = true;
    });

  }

  private async presentNoMultipleToast(message: string, color: string, duration: number = DEFAULT_DURATION_TIME, otherConfig: any = {}) {
    if (!this.dismissedToast) {
      return;
    }

    await this.presentToast(message, color, duration, otherConfig);
  }

}
